module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Dp9Eg0/tc-custom/9781504076401.jpg?1723836047849",
      "alt": "This image is the cover for the book Senseless"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Senseless\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The damage inflicted on a killer has led him into darkness—and a London detective now faces the most puzzling case of his career, in this taut crime thriller.")]), _c('br'), _c('br'), _vm._v(" From the moment he entered the world, Martin was cursed—suffering from withdrawal symptoms because of his mother’s drug abuse, taken home to a world of hunger, pain, and neglect. Eventually landing in care, his sensory abilities are nearly destroyed after years of violence inflicted on him by his mother’s boyfriends."), _c('br'), _c('br'), _vm._v(" Tormented by his life as an outcast, Martin dreams of being able to hear and smell and taste like ordinary people—and in a desperate bid to feel alive, he turns to murder . . ."), _c('br'), _c('br'), _vm._v(" DI Ruben Jameson suddenly finds himself tracking a serial killer. But as he braces himself for the usual escalation and provocation, events take a strange turn—and for the first time, he wonders if he may be dealing with a predator who is trying to stop himself. Now Jameson must find the perpetrator before he slips quietly back into anonymity, never to face justice . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Luke Delaney\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0